/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TagIcon32Regular = forwardRef('TagIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8 17.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.163 5a5.5 5.5 0 0 0-4.295 2.064l-4.65 5.813a5 5 0 0 0 0 6.246l4.65 5.813A5.5 5.5 0 0 0 10.163 27H24.5a5.5 5.5 0 0 0 5.5-5.5v-11A5.5 5.5 0 0 0 24.5 5H10.163ZM7.43 8.314A3.5 3.5 0 0 1 10.163 7H24.5a3.5 3.5 0 0 1 3.5 3.5v11a3.5 3.5 0 0 1-3.5 3.5H10.163a3.5 3.5 0 0 1-2.733-1.314l-4.65-5.812a3 3 0 0 1 0-3.748l4.65-5.812Z" })));
});
